import { Stack, Box, Typography, Chip, IconButton } from "@mui/material";
import CustomTable from "global/components/CustomTable/CustomTable";
import {
  convertESTtoUserLocalTime,
  handleErrorMessage,
  openWarningNotification,
} from "helpers/methods";
import CenteredCardLayout from "layouts/CenteredTableView/CenteredCardLayout";
import { useState, useEffect } from "react";
import { getInvoiceDetail, getInvoiceDetailCount } from "../PlanService";
import DownloadIcon from "@mui/icons-material/Download";

const invoiceDetailHeader = [
  {
    name: "Invoice #",
    field: "invoiceNumber",
  },
  {
    name: "Plan",
    field: "planName",
  },
  {
    name: "Start Date",
    field: "startDate",
  },
  {
    name: "End Date",
    field: "endDate",
  },
  {
    name: "Status",
    field: "paymentStatus",
  },
  {
    name: "Action",
    field: "invoiceUrl",
    hide: true,
  },
];

const BillingDetails = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [invoiceList, setInvoiceList] = useState<any>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState<number>();
  const [jumpToPageNumber, setJumpToPageNumber] = useState<number>(1);
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    getActiveData(page ? page : 1);
    setJumpToPageNumber(page ? page : 1);
    setRowsPerPage(rowsPerPage ? rowsPerPage : 10);
  }, [page, rowsPerPage]);

  const getActiveData = async (page: number) => {
    try {
      setIsLoading(true);
      const [invoiceDetail, invoiceCount] = await Promise.all([
        getInvoiceDetail(page, rowsPerPage),
        getInvoiceDetailCount(),
      ]);
      const resInvoiceDetail = convertTableInvoiceData(invoiceDetail);
      setInvoiceList(resInvoiceDetail);
      setCount(invoiceCount);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handlePageChange = (event: any, pageNumber: number) => {
    setPage(pageNumber);
    setRowsPerPage(rowsPerPage);
    setJumpToPageNumber(pageNumber);
  };

  const handleRowsPerPage = (rowPerPage: number) => {
    setRowsPerPage(rowPerPage);
    setPage(1);
  };

  const handleOnChangePageInput = (newPage: number, count: number) => {
    setJumpToPageNumber(newPage);
    if (newPage && newPage >= 1 && newPage <= count) {
      setPage(1);
      setRowsPerPage(rowsPerPage);
    } else if (!newPage) {
      openWarningNotification("Please fill in the jump to page field.");
    }
  };

  const convertTableInvoiceData = (data: string[]) => {
    return data.map((item: any, index: number) => {
      return {
        invoiceNumber: item.invoiceNumber,
        planName: item.planName,
        startDate: convertESTtoUserLocalTime(
          item.startDate,
          "MM/DD/YYYY",
          "MMMM D, YYYY"
        ),
        endDate: convertESTtoUserLocalTime(
          item.endDate,
          "MM/DD/YYYY",
          "MMMM D, YYYY"
        ),
        paymentStatus: (
          <Typography
            sx={{
              color:
                item.paymentStatus.toLowerCase() === "paid"
                  ? "#47AA12"
                  : "#475569",
              display: "flex",
              alignItems: "center",
            }}
            variant="subtitle2"
          >
            {item.paymentStatus}
          </Typography>
        ),
        invoiceUrl: (
          <>
            <IconButton
              onClick={() => {
                window.open(item.invoiceUrl, "_blank");
              }}
            >
              <DownloadIcon />
            </IconButton>
          </>
        ),
      };
    });
  };

  const getBillings = () => {
    return (
      <Stack direction="column" spacing={2}>
        <CenteredCardLayout removeLastChildBottomPadding={true}>
          <Box>
            <CustomTable
              headers={invoiceDetailHeader}
              rows={invoiceList}
              page={page}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleRowsPerPage}
              onPageChange={handlePageChange}
              count={count}
              jumpToPageNumber={jumpToPageNumber}
              showJumpToPageNumber={true}
              setJumpToPageNumber={setJumpToPageNumber}
              handleOnChangePageInput={handleOnChangePageInput}
              showPagination={true}
              isLoading={isLoading}
            />
          </Box>
        </CenteredCardLayout>
      </Stack>
    );
  };
  return <>{getBillings()}</>;
};

export default BillingDetails;
